import { Component } from "@angular/core";
import { Location } from "@angular/common";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  API_URL_ADD_MATCHING,
  API_URL_GET_LIST_TITLE_APPLICATION
} from "manager/http-constants";
import { forkJoin, Observable } from "rxjs";
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from "src/app/shared/constant/api-constant";
import { CONSTANT, LOADING_KEY } from "src/app/shared/constant/constant";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { TOAST } from "src/app/shared/constant/primeng-constants";
import {
  LoadData,
  LoadingState,
} from "src/app/shared/html-parts/loading/loading-state";
import {
  MessageData,
  ToastMessageData,
} from "src/app/shared/html-parts/message-common/message-data";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import { Validator } from "src/app/shared/validator/validator";
import { GENERATE_INPUT_TYPE } from "src/app/shared/generate/generate-input/constant";
import { PlatformComponent } from "../platform.component";
import { SESSION_KEY } from "../../../shared/constant/session-constants";
import { LoginService } from "src/app/shared/service/login.service";

@Component({
  selector: "app-c431",
  templateUrl: "./c431.component.html",
  styleUrls: ["./c431.component.scss", "../platform.component.scss"],
})

/**
 * 提案登録(C431)
 * 提案登録確認(C432)
 */
export class C431Component extends PlatformComponent {
  // 画面.入力フォーム
  c431InputForm: FormGroup;

  // 課題IDを格納
  agendaId: string = this.route.snapshot.queryParams.agenda_id;

  // 提案IDを格納
  suggestId: string = this.route.snapshot.queryParams.suggest_id;

  matchType: number = this.route.snapshot.queryParams.match_type;

  // 課題・ソリューション詳細格納先
  detailTask: any;

  // 確認画面表示フラグ(true=提案登録確認(C432),false=提案登録(C431))
  confirmationFlag: boolean = false;

  roleAuth: any;
  titleMulti: string;
  isDataLoaded: boolean = false;
  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData,
    private location: Location,
    public loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);

    // urlを提案登録(C431)に変更する
    this.router.navigate(["pages/platform/c401/" + this.inputType], {
      queryParams: {
        screenId: "c401",
        agenda_id: this.agendaId,
        suggest_id: this.suggestId,
        match_type: this.matchType
      },
    });
  }

  public ngOnInit() {
    this.initForm();
    // ユーザマスタに存在する場合
    this.getUserClassId();
    // 課題一覧を取得
    this.getDetailTask();

  }

  public getUserClassId(): string | void {
    this.loginService.getLoginUser().subscribe((response) => {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3);

      // ログインユーザ情報がユーザマスタに存在するか否か
      if (this.commonService.checkNoneResponse(response)) {
        // ユーザマスタに存在しない場合

        // 不正なユーザの為、ログアウト処理
        this.loginService.logout(MESSAGE_CODE.E90000);

        // 処理を終了
        return;
      } else {
        // ユーザマスタに存在する場合
        this.roleAuth = response.body.class_id;
      }
    });
  }

  private initForm() {
    this.c431InputForm = this.formBuilder.group({
      // 提案タイトル
      desired_ldatetime: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
        asyncValidators: [
          this.validator.CheckValidator(
            "match",
            "desired_ldatetime",
            INPUT_INFORMATIONS_API_CONSTANT.DATE_TYPE
          ),
        ],
      }),
      // 提案詳細内容
      desired_lpeople_number: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
        asyncValidators: [
          this.validator.CheckValidator(
            "match",
            "desired_lpeople_number",
            INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
          ),
        ],
      }),
      // 導入事例・実績等など
      desired_location: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
        asyncValidators: [
          this.validator.CheckValidator(
            "match",
            "desired_location",
            INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
          ),
        ],
      }),
      // 提案詳細内容
      desired_content: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
        asyncValidators: [
          this.validator.CheckValidator(
            "match",
            "desired_content",
            INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
          ),
        ],
      }),
      // 導入事例・実績等など
      manager_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
        asyncValidators: [
          this.validator.CheckValidator(
            "match",
            "manager_name",
            INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
          ),
        ],
      }),
    });
  }


  public getUrlMatchType() {
    return this.matchType == 1 ? API_URL_GET_LIST_TITLE_APPLICATION : API_URL_GET_LIST_TITLE_APPLICATION;
  }

  /**
   * 課題・ソリューション詳細を取得
   */
  private getDetailTask(): void {

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart();
    const url = this.commonService.url(
      API_URL_GET_LIST_TITLE_APPLICATION,
      '?agenda_id=',
      this.agendaId,
      '&match_type=',
      this.matchType
    );

    // 課題・ソリューション詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(url, '')
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3,);

        if (this.commonService.checkInvalidValue(response)) {
          this.isDataLoaded = false;
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );

          // 前画面へ戻る
          this.location.back();
        } else {
          this.isDataLoaded = true;
          // 課題・ソリューション詳細を格納
          this.detailTask = response.body;
          this.titleMulti = `全${this.detailTask.length}件の申し込み`
        }
      });
  }


  /**
   * 提案登録(C431)を表示する
   */
  public moveC431(): void {
    // 提案登録(C431)へ遷移
    this.router.navigate(["pages/platform/c401/" + this.inputType], {
      queryParams: { screenId: "c401", agenda_id: this.agendaId, match_type: this.matchType },
    });

    // 提案登録(C431)を表示する
    this.confirmationFlag = false;
  }

  /**
   * 提案登録確認(C432)を表示する
   */
  public moveC432(): void {
    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: "",
        background_color: "",
        opacity: 0.3,
      })
    );

    /* 入力項目値バリデーションチェック */
    // 非同期同時実行リスト
    let task: Observable<any>[] = [
      /* 共通バリデーションチェック */
      this.dbOperationService.multiValidationResult(
        "match",
        this.c431InputForm.value
      ),
    ];

    // 非同期同時実行
    forkJoin(task).subscribe((dataList) => {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadEnd();

      // 提案登録確認(C432)へ遷移
      this.router.navigate(["pages/platform/c401/" + this.inputType], {
        queryParams: { screenId: "c402", agenda_id: this.agendaId, match_type: this.matchType },
      });

      // 提案登録確認(C432)を表示する
      this.confirmationFlag = true;
    });
  }

  /**
   * 提案登録完了(C433)を表示する
   */
  public moveC433(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let c431InputForm: any = JSON.parse(
      JSON.stringify(this.c431InputForm.value)
    );

    // 課題・ソリューションID
    c431InputForm.agenda_id = this.agendaId;

    // 会員ID
    // c431InputForm.member_id = this.getLoginMemberId();

    c431InputForm.match_type = this.matchType;

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
      // 新規登録の場合

      // 提案登録を実施
      this.dbOperationService
        .insertData(API_URL_ADD_MATCHING, c431InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // 提案登録完了(C433)へ遷移
            this.router.navigate(["pages/platform/c403"],
              {
                state:
                {
                  agenda: this.detailTask?.agenda,
                  role: this.roleAuth
                },
                queryParams: {
                  matchType: this.matchType
                }
              }
            );
          } if (this.commonService.checkInvalidValue(response)) {
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.WARN,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E00026),
              })
            );

            // 前画面へ戻る
            this.location.back();
            this.location.back();
          } else if (API_RESPONSE.FAIL == response.body.Message) {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // 提案登録(C431)を表示する
            this.confirmationFlag = false;
          } else {
            // 提案上限の場合

            // 提案登録(C431)を表示する
            this.confirmationFlag = false;
          }
        });
    } else if (GENERATE_INPUT_TYPE.EDIT == this.inputType) {
      // 編集の場合

      // 提案更新を実施
      this.dbOperationService
        .updateData(API_URL_ADD_MATCHING, this.suggestId, c431InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // 提案登録完了(C433)へ遷移
            this.router.navigate(["pages/platform/c403"], {
              queryParams: {
                matchType: this.matchType,
              }
            });
          } else {
            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // 提案登録(C431)を表示する
            this.confirmationFlag = false;
          }
        });
    }
  }
}
